module.exports = __webpack_public_path__ + "static/increds-4182abdc4112f761b5231a78ada81a71.gif";